import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const SIMPLEHEADERBLOCK_LEGACY_FIELD_ORDER = [
  "height",
  "background_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  simpleHeaderBlockDescriptor: _generatedSimpleHeaderBlockDescriptor,
  simpleHeaderBlockBlocDefinition,
  simpleHeaderBlockDashboardLayout,
  simpleHeaderBlockConfig,
  simpleHeaderBlockResolveConfig,
  simpleHeaderBlockProperties,
} = doodBlockConfig(
  {
    name: "Simple header",
    componentType: "SimpleHeaderBlockComponent",
    category: "navigation",
    description: "Simple header.",
    keywords: [],
    allowedIn: [
      { bloc: 'StickyBlockComponent', slot: '*' },
      { bloc: 'CartPageComponent', slot: '*' },
    ],
    sharedFields: {},
    slots: [
      {
        key: "left_items",
        name: "pages.blocks.simple-header.left-items.label",
        accept: "explicitOnly",
        allowedTypes: ["SimpleHeader.*ItemBlock(?:Component)?"],
        slotItemFormat: "ids",
      },
      {
        key: "middle_items",
        name: "pages.blocks.simple-header.middle-items.label",
        accept: "explicitOnly",
        allowedTypes: ["SimpleHeader.*ItemBlock(?:Component)?"],
        slotItemFormat: "ids",
      },
      {
        key: "right_items",
        name: "pages.blocks.simple-header.right-items.label",
        accept: "explicitOnly",
        allowedTypes: ["SimpleHeader.*ItemBlock(?:Component)?"],
        slotItemFormat: "ids",
      },
    ],
  },

  () => ({
    height: propertyValue({
      type: "text",
      value: "70",
      options: {
        label: "pages.blocks.simple-header.height.label",
        help: "pages.blocks.simple-header.height.help",
      },
    }),
    background_color: propertyValue({
      type: "color",
      value: { type: "hex", value: "#FFFFFF" },
      options: {
        label: "pages.blocks.simple-header.background-color.label",
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.simple-header.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.simple-header.fieldset.appearance.label",
            fields: ["height", "background_color"],
          },
          {
            legend: "pages.blocks.simple-header.fieldset.items.label",
            fields: ["left_items", "middle_items", "right_items"],
          },
        ],
      },
    ],
  }),
);

export function simpleHeaderBlockDescriptor(): IBlockDescriptor;
export function simpleHeaderBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function simpleHeaderBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedSimpleHeaderBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedSimpleHeaderBlockDescriptor,
    simpleHeaderBlockProperties,
    fieldOrder,
  );
}

export {
  simpleHeaderBlockBlocDefinition,
  simpleHeaderBlockDashboardLayout,
  simpleHeaderBlockProperties,
  simpleHeaderBlockConfig,
  simpleHeaderBlockResolveConfig,
};

export type SimpleHeaderBlockConfig = typeof simpleHeaderBlockConfig;
